import {IFetchAvailableLanguagesAction, IUpdateAvailableLanguagesAction, IUpdatePlayerDefaultLabelsAction} from './types/language.types';

export const FETCH_PLAYER_DEFAULT_LABELS = 'FETCH_PLAYER_DEFAULT_LABELS';
export const FETCH_AVAILABLE_LANGUAGES = 'FETCH_AVAILABLE_LANGUAGES';
export const UPDATE_PLAYER_DEFAULT_LABELS = 'UPDATE_PLAYER_DEFAULT_LABELS';
export const UPDATE_AVAILABLE_LANGUAGES = 'UPDATE_AVAILABLE_LANGUAGES';

export const fetchAvailableLanguagesAction = (): IFetchAvailableLanguagesAction => ({
    type: FETCH_AVAILABLE_LANGUAGES,
});

export const updatePlayerDefaultLabelsAction = (labels: Record<string, string>[]): IUpdatePlayerDefaultLabelsAction => ({
    type: UPDATE_PLAYER_DEFAULT_LABELS,
    labels,
});

export const updateAvailableLanguagesAction = (langs: {code: string}[]): IUpdateAvailableLanguagesAction => ({
    type: UPDATE_AVAILABLE_LANGUAGES,
    availableLanguages: langs,
});
